/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Eu_TitleInputs */

const en_about_eu_title = /** @type {(inputs: About_Eu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-Based & Privacy-Focused`)
};

const de_about_eu_title = /** @type {(inputs: About_Eu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-basiert & datenschutzbewusst`)
};

const fr_about_eu_title = /** @type {(inputs: About_Eu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basé dans l'UE, axé sur la confidentialité`)
};

const es_about_eu_title = /** @type {(inputs: About_Eu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con sede en la UE, orientado a la privacidad`)
};

const it_about_eu_title = /** @type {(inputs: About_Eu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con sede nell'UE, orientato alla privacy`)
};

const nl_about_eu_title = /** @type {(inputs: About_Eu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-gebaseerd & privacygericht`)
};

const pl_about_eu_title = /** @type {(inputs: About_Eu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z siedziba w UE, zorientowane na prywatnosc`)
};

const fi_about_eu_title = /** @type {(inputs: About_Eu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-pohjainen ja yksityisyyttae kunnioittava`)
};

const da_about_eu_title = /** @type {(inputs: About_Eu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-baseret & fortrolighedsfokuseret`)
};

const sv_about_eu_title = /** @type {(inputs: About_Eu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-baserat & integritetsfokuserat`)
};

/**
* | output |
* | --- |
* | "EU-Based & Privacy-Focused" |
*
* @param {About_Eu_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_eu_title = /** @type {((inputs?: About_Eu_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Eu_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_eu_title(inputs)
	if (locale === "fr") return fr_about_eu_title(inputs)
	if (locale === "es") return es_about_eu_title(inputs)
	if (locale === "it") return it_about_eu_title(inputs)
	if (locale === "nl") return nl_about_eu_title(inputs)
	if (locale === "pl") return pl_about_eu_title(inputs)
	if (locale === "fi") return fi_about_eu_title(inputs)
	if (locale === "da") return da_about_eu_title(inputs)
	if (locale === "sv") return sv_about_eu_title(inputs)
	return en_about_eu_title(inputs)
});